import { Link } from "react-router-dom";
import { useState } from "react";
import ModalPelatihan from "./ModalPelatihan";
const PelatihanDaring = () => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="Daring-Container">
      <p className="Daring-Title">Pelatihan Daring</p>
      <div className="Daring-Card">
        <img
          className="ImgDaring"
          src="http://via.placeholder.com/200x270"
          alt="banner kelas tatap muka 1"
        />
        <div className="IsiBannerDaring">
          <p className="daringCard-title">Digital Marketing</p>
          <p className="daringCard-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.{" "}
          </p>
          <div className="Detail-Button-Container">
            <table className="daringTable">
              <tr>
                <td>Tanggal</td>
                <td> :</td>
                <td>Jumat, 22 April 2022</td>
              </tr>
              <tr>
                <td>Jam</td>
                <td>:</td>
                <td>10:00 WIB</td>
              </tr>
              <tr>
                <td>Tempat</td>
                <td> :</td>
                <td>Online</td>
              </tr>
              <tr>
                <td>Kapasitas</td>
                <td> :</td>
                <td>100 Orang</td>
              </tr>

              <tr>
                <td>Pembicara</td>
                <td> :</td>
                <td>kenny melvern</td>
              </tr>
            </table>
            <Link to="/DigitalMarketing">
              <button>Daftar</button>
            </Link>
          </div>
        </div>
      </div>

      {openModal && <ModalPelatihan openModal={setOpenModal} />}

      <div className="Daring-Card">
        <img
          className="ImgDaring"
          src="http://via.placeholder.com/200x270"
          alt="banner kelas tatap muka 1"
        />
        <div className="IsiBannerDaring">
          <p className="daringCard-title">Digital Marketing</p>
          <p className="daringCard-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.{" "}
          </p>
          <div className="Detail-Button-Container">
            <table className="daringTable">
              <tr>
                <td>Tanggal</td>
                <td> :</td>
                <td>Jumat, 22 April 2022</td>
              </tr>
              <tr>
                <td>Jam</td>
                <td>:</td>
                <td>09:00 WIB</td>
              </tr>
              <tr>
                <td>Tempat</td>
                <td> :</td>
                <td>Online</td>
              </tr>
              <tr>
                <td>Kapasitas</td>
                <td> :</td>
                <td>100 Orang</td>
              </tr>

              <tr>
                <td>Pembicara</td>
                <td> :</td>
                <td>kenny melvern</td>
              </tr>
            </table>
            <Link to="/DigitalMarketing">
              <button>Daftar</button>
            </Link>
          </div>
        </div>
      </div>

      <div className="Daring-Card">
        <img
          className="ImgDaring"
          src="http://via.placeholder.com/200x270"
          alt="banner kelas tatap muka 1"
        />
        <div className="IsiBannerDaring">
          <p className="daringCard-title">Digital Marketing</p>
          <p className="daringCard-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.{" "}
          </p>
          <div className="Detail-Button-Container">
            <table className="daringTable">
              <tr>
                <td>Tanggal</td>
                <td> :</td>
                <td>Jumat, 22 April 2022</td>
              </tr>
              <tr>
                <td>Jam</td>
                <td>:</td>
                <td>13:00 WIB</td>
              </tr>
              <tr>
                <td>Tempat</td>
                <td> :</td>
                <td>Kampus Bina Nusantara Bandung</td>
              </tr>
              <tr>
                <td>Kapasitas</td>
                <td> :</td>
                <td>100 Orang</td>
              </tr>

              <tr>
                <td>Pembicara</td>
                <td> :</td>
                <td>kenny melvern</td>
              </tr>
            </table>
            <Link to="/DigitalMarketing">
              <button>Daftar</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PelatihanDaring;
